import React from 'react'
import styles from './SmallSpinner.module.css'

const SmallSpinner = () => {
    return <div className={styles.SmallSpinner} />
}

export default SmallSpinner